import { IFilterSelectItem } from '@/types/IFilterSelectItem';

interface IFilterSelectItemWithAlias extends IFilterSelectItem {
    alias: string;
}

interface IPriceTypeResponse {
    body: IFilterSelectItemWithAlias[];
}

export const PRICE_TYPES: IPriceTypeResponse = {
    body: [
        {
            value: 0,
            alias: 'fixed',
            text: 'Фикс',
        },
        {
            value: 1,
            alias: 'free',
            text: 'Бесплатно',
        },
        {
            value: 2,
            alias: 'from',
            text: 'От',
        },
    ],
};

export default PRICE_TYPES;
